import CloseIcon from "@mui/icons-material/Close";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
} from "@mui/material";
import { Button } from "pepsico-ds";
import { useState } from "react";
import ProductGroupsTable from "./ProductGroupsTable";
import "./productManagement.scss";

const ProductGroupsListView = ({
  productGroups,
  allProducts,
  loading,
  onViewGroup,
  onAddGroup,
  onEditGroup,
  onDeleteGroup,
}) => {
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [targetGroup, setTargetGroup] = useState(null);

  const handleDeleteGroup = (group) => {
    setTargetGroup(group);
    setDeleteModalOpen(true);
  };

  const handleDeleteClose = () => {
    setDeleteModalOpen(false);
    setTargetGroup(null);
  };

  const handleDeleteConfirm = () => {
    if (targetGroup && onDeleteGroup) {
      onDeleteGroup(targetGroup);
    }
    handleDeleteClose();
  };

  return (
    <div className="product-groups-list-view">
      <div className="product-groups-list-actions">
        <Button
          text="Create Product Group"
          variant="primary"
          onClick={onAddGroup}
          className="add-product-group-btn"
        />
      </div>
      <ProductGroupsTable
        productGroups={productGroups}
        allProducts={allProducts}
        loading={loading}
        onViewGroup={onViewGroup}
        onEditGroup={onEditGroup}
        onDeleteGroup={handleDeleteGroup}
      />

      <Dialog
        open={deleteModalOpen}
        onClose={handleDeleteClose}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle>
          <Grid container justifyContent="space-between" alignItems="center">
            <Grid item>
              <h3 style={{ margin: 0 }}>Remove product group?</h3>
            </Grid>
            <Grid item>
              <CloseIcon onClick={handleDeleteClose} className="cursor-pointer" />
            </Grid>
          </Grid>
        </DialogTitle>
        <DialogContent>
          <p style={{ margin: 0 }}>
            Are you sure you want to remove this group? This action can&apos;t be
            undone.
          </p>
        </DialogContent>
        <DialogActions>
          <Button
            variant="secondary"
            onClick={handleDeleteClose}
            text="Cancel"
            size="small"
          />
          <Button
            variant="primary"
            onClick={handleDeleteConfirm}
            text="Remove"
            size="small"
          />
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default ProductGroupsListView;
